import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router,
    Switch,
    Route
} from 'react-router-dom'
import {Provider} from 'react-redux'
import { CookiesProvider } from 'react-cookie'
import SetPassword from './utils/SetPassword'

import './master.scss'

import AgendaLogger from '@invintusmedia/agenda-logger'
import history from './history'
import AuthSelector from './AuthSelector'
import store from './redux/store'
import { initTracking } from './lib/tracking'

var MountWrapper = (function () {
    const mountNode = document.getElementById('workspace')

    window.AgendaLogger = AgendaLogger

    return {
        launch: (...args) => {
            // Boot product analytics before render so SPA page_views + identify
            // are wired regardless of auth state. No-op when no GA4 ID resolves.
            initTracking()
            ReactDOM.render(
                <>
                    <Provider store={store}>
                        <Router history={history}>
                            <Switch>
                                <Route exact path="/auth/reset/:token">
                                    <SetPassword {...history} />
                                </Route>
                                <Route path='/' >
                                    <CookiesProvider
                                        secure='true'
                                        sameSite='none'>
                                        <AuthSelector args={args}/>
                                    </CookiesProvider>
                                </Route>
                            </Switch>
                        </Router>
                    </Provider>
                </>,
                mountNode
            )
        }
    }
})()

window.App = MountWrapper
export default MountWrapper